import { makeStyles } from '@material-ui/core/styles';
import { COLORS, DIMENSIONS } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1,
		height: props => (props.fullHeight ? '100%' : 'auto'),
		border: `1px solid ${COLORS.BORDER}`
	},
	content: {
		padding: props => (props.title ? `0 ${theme.spacing(3)}px` : '0 !important'),
		'&:last-child': {
			paddingBottom: theme.spacing(3)
		}
	},
	actions: {
		padding: 0
	}
}));

export const useHeaderStyles = makeStyles(theme => ({
	root: {
		height: DIMENSIONS.CARD_HEADER_HEIGHT,
		padding: 0,
		paddingLeft: theme.spacing(3),
		paddingRight: props => (props.titleAction ? 0 : theme.spacing(3)),
		'& .MuiIconButton-root': {
			'&:focus': {
				boxShadow: ''
			}
		}
	},
	action: {
		marginTop: theme.spacing(0.5),
		marginRight: theme.spacing(0.5)
	}
}));

export const useTableRowStyles = makeStyles({
	root: {
		'&:last-child td': {
			paddingBottom: props => (!props.isVinNomSet ? 0 : undefined)
		}
	}
});

export const useTableCellStyles = makeStyles({
	root: {
		padding: '4px 8px 4px 0px',
		border: 'none',
		'&:last-child': {
			paddingRight: 0
		}
	}
});
